import cx from 'classnames'
import { Card } from '@bpinternal/ui-kit-next'

export type ListProps<T> = {
  items: T[]
  children?: React.ReactNode | ((item: T) => React.ReactNode)
  divider?: React.ReactNode
} & Omit<React.ComponentProps<typeof Card>, 'children'>

export const List = <T,>({
  items,
  children,
  divider = <div className="h-px w-full bg-border" />,
  ...props
}: ListProps<T>) => {
  if (!items.length) {
    return null
  }

  return (
    <Card {...props} className={cx('rounded-sm p-0', props.className)}>
      {items.map((item, i) => {
        return (
          <div key={i}>
            {i !== 0 && divider}
            {typeof children === 'function' ? children(item) : children}
          </div>
        )
      })}
    </Card>
  )
}
